<template>
<kt-icon class="kt-nav__link-icon" :type="type" :name="name"></kt-icon>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'fa'
        },
        name: {
            type: String,
            required: true,
        },
    }
}
</script>